import React from "react";
import { Sparkles } from "lucide-react";

import { Button } from "components/Graphs/Button";
import { Input } from "components/Graphs/Input";
import { generateEnvironmentDisplayName } from "utils/defaultEnvironmentDisplayName";
import { StepHeading } from "../components";

export const ComputeNameStep: React.FC<{
  computeName: string;
  isSettled: boolean;
  nameError: string;
  onNameChange: (value: string, completeImmediately?: boolean) => void;
  onValidate: (value: string) => void;
}> = ({ computeName, isSettled, nameError, onNameChange, onValidate }) => (
  <section className="flex flex-col gap-3 rounded-lg border border-zinc-800 px-4 py-5">
    <StepHeading
      number={1}
      isReady={isSettled}
      highlightWhenReady
      labelId="register-compute-name-label"
    >
      Name your compute
    </StepHeading>
    <div className="ml-9 flex min-w-0 flex-col gap-1">
      <div className="flex items-stretch gap-2">
        <Input
          id="register-compute-name"
          type="text"
          value={computeName}
          onChange={(event) => onNameChange(event.target.value)}
          autoFocus
          onBlur={(event) => {
            if (
              (event.relatedTarget as HTMLElement | null)?.id ===
              "register-compute-generate-name"
            ) {
              return;
            }
            onValidate(computeName);
          }}
          placeholder="e.g. gpu-workstation"
          required
          aria-labelledby="register-compute-name-label"
          aria-invalid={nameError ? "true" : undefined}
          aria-describedby={
            nameError ? "register-compute-name-error" : undefined
          }
          hasError={Boolean(nameError)}
          className="min-w-0 flex-1"
        />
        <Button
          id="register-compute-generate-name"
          type="button"
          variant="secondary"
          className="shrink-0 gap-2"
          onClick={() => onNameChange(generateEnvironmentDisplayName(), true)}
        >
          <Sparkles
            aria-hidden="true"
            className="h-4 w-4 fill-current"
            strokeWidth={1}
          />
          Generate name
        </Button>
      </div>
      {nameError ? (
        <p
          id="register-compute-name-error"
          className="text-sm text-red-400 mt-1"
          role="alert"
        >
          {nameError}
        </p>
      ) : null}
    </div>
  </section>
);
